import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ConversationalSimulationCasePageForNRO = lazy(() =>
  import("@scenes/ConversationalSimulations").then((module) => ({
    default: module.ConversationalSimulationCasePage,
  }))
);

export const conversationalSimulationCaseCreateNRO: NavigationRoutingObject = {
  Component: ConversationalSimulationCasePageForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("conversational-simulation-case-create-nro-heading", "New Simulation Case"),
  pageNameForTracking: () => "Create Conversational Simulation Case",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("agent_console_conversational");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/conversational/simulations/:appGroupId",
};
